<template>
  <div aria-label="Page navigation" class="mt-3" v-if="pagination.last_page > 1">
    <div class="d-flex justify-content-center mb-3">
      <input
        class="form-control form-control-sm w-mx-content"
        type="number"
        min="1"
        v-model="enteredPage"
        @keyup.enter="getPage"
        :placeholder="Lang.get('messages.goto_page')"  
      />
    </div>

    <div class="pagination-block flex">
      <!-- First Page -->
      <a href="#" class="page-btn flex" @click.prevent="changePage(1)"  :class="{ disabled: pagination.current_page === 1 }">
        {{ Lang.get('pagination.first_page') }}
      </a>

      <!-- Pagination -->
      <ul class="pagination">
        <!-- Previous -->
          <li class="page-item" :class="{ disabled: pagination.current_page === 1 }">
            <a
              class="page-link next"
              href="#"
              :title="Lang.get('pagination.previous')"
              @click.prevent="changePage(pagination.current_page - 1)"
            >
              <i class="fas fa-angle-double-right"></i>
            </a>
        </li>

        <!-- Page Numbers -->
        <li
          class="page-item"
          v-for="page in pages"
          :key="page"
          :class="{ active: isCurrentPage(page) }"
        >
          <a href="#" class="page-link" @click.prevent="changePage(page)">
            {{ page }}
          </a>
        </li>

        <!-- Next -->
        <li class="page-item" :class="{ disabled: pagination.current_page >= pagination.last_page }">
          <a
            class="page-link previous"
            href="#"
            :title="Lang.get('pagination.next')"
            @click.prevent="changePage(pagination.current_page + 1)"
          >
            <i class="fas fa-angle-double-left"></i>
          </a>
        </li>
      </ul>

      <!-- Last Page -->
      <a href="#" class="page-btn flex" @click.prevent="changePage(pagination.last_page)" :class="{ disabled: pagination.current_page === pagination.last_page }">
        {{ Lang.get('pagination.last_page') }}
      </a>
    </div>

    <!-- Summary -->
    <div class="pages-number flex mt-2">
      {{ Lang.get('messages.total') }} <span>{{ pagination.total }}</span>
      {{ Lang.get('messages.pagination.records') }} ,
      {{ Lang.get('messages.pagination.showing_from') }}
      <span>{{ pagination.from }}</span>
      {{ Lang.get('messages.to') }}
      <span>{{ pagination.to }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    pagination: {
      type: [Object, Array],
      required: true,
    },
    offset: {
      type: Number,
      default: 5,
    },
  },
  data() {
    return {
      enteredPage: '',
    };
  },
  methods: {
    isCurrentPage(page) {
      return this.pagination.current_page === page;
    },
    changePage(page) {
      if (page > this.pagination.last_page) {
        page = this.pagination.last_page;
      }
      if (page < 1) {
        page = 1;
      }
    
      setTimeout(() => {
        this.$emit('paginate', page);
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        }
        );
      }, 500);

      // this.$emit('paginate', page);
      // window.scrollTo(0, 0);
    },
    getPage() {
      if (
        _.isEmpty(this.enteredPage) ||
        this.enteredPage <= 0 ||
        this.enteredPage > this.pagination.last_page
      ) {
        return false;
      }
      
      setTimeout(() => {
        this.changePage(this.enteredPage);
      }, 500);
      // this.changePage(this.enteredPage);
    },
  },
  computed: {
    pages() {
      let pages = [];
      let from = this.pagination.current_page - Math.floor(this.offset / 2);
      if (from < 1) {
        from = 1;
      }
      let to = from + this.offset - 1;
      if (to > this.pagination.last_page) {
        to = this.pagination.last_page;
      }
      while (from <= to) {
        pages.push(from);
        from++;
      }
      return pages;
    },
  },
};
</script>

<style scoped>
.page-item.disabled .page-link {
  pointer-events: none;
  opacity: 0.5;
}

.page-item.active .page-link {
  font-weight: bold;
  background: var(--primary);
  color: white;
}
.page-btn.disabled {
  pointer-events: none;
  opacity: 0.5;
}
</style>
